export const QUOTE_STATUS_OPTIONS = [
  { value: "draft", label: "Draft" },
  { value: "confirmed", label: "Confirmed" },
  { value: "sent", label: "Submitted" },
  { value: "accepted", label: "Accepted" },
  { value: "rejected", label: "Rejected" },
] as const;

export type QuoteStatusValue = (typeof QUOTE_STATUS_OPTIONS)[number]["value"];

export function getQuoteStatusLabel(status: string): string {
  return QUOTE_STATUS_OPTIONS.find((option) => option.value === status)?.label ?? status;
}